import { makeScalarToken } from '@utils/css';

const aspectRatio = makeScalarToken("--aspect", "0.75");
const box = "_35sbiorp78";
const printWrapper = "_35sp1wf48n4";
const printThumbnail = "_35spxix8i9";
const printPlayIcon = "_35sp109f4kj";

export { aspectRatio, box, printPlayIcon, printThumbnail, printWrapper };
import "./input.video.style.linaria.module.css";
//# sourceMappingURL=input.video.style.js.map
